import { type Breakpoint, Stack, type StackProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DashboardHeaderStack = styled<React.FC<StackProps & { breakpoint?: Breakpoint }>>(Stack, {
  shouldForwardProp: (prop) => prop !== "breakpoint",
})(({ theme, breakpoint = "desktop" }) => ({
  padding: `${theme.spacing(4)} ${theme.spacing(8)}`,
  [theme.breakpoints.down(breakpoint)]: {
    padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(2)}`,
  },
}));
